import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Input, InputGroup, InputGroupAddon } from 'reactstrap';
import withInputErrorMessage from '../withInputErrorMessage';
import withUseEffectErrorMessage from './withUseEffectErrorMessage';

const withPixelInput = (PixelInputComponent) => {
   const InnerWithPixelInput = (props) => {
      const {
         field: propsField,
         form: propsForm,
         ...restProps
      } = props;

      const handleChange = useCallback((e) => {
         props.form.setFieldValue(props.field.name, e?.target?.value);
      }, []);

      const handleChangeNonEvent = useCallback((newInputValue) => {
         props.form.setFieldValue(props.field.name, newInputValue);
      }, []);

      return (
         <PixelInputComponent
            { ...props.field }
            onChange={ handleChange }
            onChangeNonEvent={ handleChangeNonEvent }
            { ...restProps }
         />
      );
   };

   InnerWithPixelInput.propTypes = {
      field: PropTypes.shape({
         name: PropTypes.string.isRequired,
         onChange: PropTypes.func.isRequired,
         onBlur: PropTypes.func.isRequired,
         value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }).isRequired,
      form: PropTypes.shape({
         touched: PropTypes.objectOf(PropTypes.any).isRequired,
         errors: PropTypes.objectOf(PropTypes.any).isRequired,
         setFieldValue: PropTypes.func.isRequired,
      }).isRequired,
      isDisabled: PropTypes.bool,
   };

   InnerWithPixelInput.defaultProps = {
      isDisabled: false,
   };

   return InnerWithPixelInput;
};


const PixelInput = (props) => {
   // Stops 'e' from breaking the input by ignoring the e input
   const handleKeyDown = useCallback((event) => {
      if (event?.key === 'e') {
         event.preventDefault();
      }
   }, []);


   const handleBlur = useCallback((e) => {
      props.onBlur(e);

      try {
         const inputValue = e?.target?.value;
         if (!Number.isNaN(inputValue)) {
            if (props.max !== undefined && +inputValue > props.max) {
               props.onChangeNonEvent(props.max);
            } else if (props.min !== undefined && +inputValue < props.min) {
               props.onChangeNonEvent(props.min);
            }
         }
      } catch (exception) {
         console.error(exception);
      }
   }, []);

   return (
      <InputGroup>
         <Input
            placeholder='Amount'
            min={props.min}
            max={props.max}
            type='number'
            step={props.step}
            onChange={props.onChange}
            value={props.value}
            disabled={props.isDisabled}
            className={props.className}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
         />
         <InputGroupAddon
            addonType='append'
         >
            px
         </InputGroupAddon>
      </InputGroup>
   );
};

PixelInput.propTypes = {
   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   min: PropTypes.number,
   max: PropTypes.number,
   step: PropTypes.string,
   onChange: PropTypes.func.isRequired,
   onBlur: PropTypes.func.isRequired,
   onChangeNonEvent: PropTypes.func.isRequired,
   isDisabled: PropTypes.bool,
   className: PropTypes.string,
};

PixelInput.defaultProps = {
   value: undefined,
   min: undefined,
   max: undefined,
   step: undefined,
   isDisabled: false,
   className: '',
};


export default withUseEffectErrorMessage(withPixelInput(withInputErrorMessage(PixelInput)));
